/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Codeeditor_Press_To_Save_MidInputs */



/**
* | output |
* | --- |
* | "to save •" |
*
* @param {Spaces_Codeeditor_Press_To_Save_MidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_codeeditor_press_to_save_mid = /** @type {((inputs?: Spaces_Codeeditor_Press_To_Save_MidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Codeeditor_Press_To_Save_MidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("um zu speichern •")
	return /** @type {LocalizedString} */ ("to save •")
});